import React from "react";
import { Link, useLocation } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import translations from "../translation";

const FOOTER_ITEMS = [
  {
    key: "home",
    labelKey: "Home",
    fallbackLabel: "Home",
    icon: HomeOutlinedIcon,
    authenticatedTo: "/",
    guestTo: "/",
  },
  {
    key: "LessonList",
    labelKey: "LearningPath",
    fallbackLabel: "Learning path",
    icon: MapOutlinedIcon,
    authenticatedTo: "/new-learning-journey",
    guestTo: "/login",
  },
  {
    key: "study-material",
    labelKey: "learning",
    fallbackLabel: "Study Material",
    icon: MenuBookOutlinedIcon,
    authenticatedTo: "/learn",
    guestTo: "/login",
  },
  {
    key: "go-japan",
    labelKey: "payment",
    fallbackLabel: "Payment",
    icon: CreditCardOutlinedIcon,
    authenticatedTo: "/plans",
    // React Native app (webview) me payment tab hamesha /AppView khole (plan ho ya na ho), web par /plans
    appAuthenticatedTo: "/AppView",
    appLabel: "Our Website",
    appAlways: true,
    guestTo: "/login",
  },
  {
    key: "profile",
    labelKey: "profile",
    fallbackLabel: "Profile",
    icon: PersonOutlineOutlinedIcon,
    authenticatedTo: "/profile",
    guestTo: "/login",
  },
];

function FooterNav({ authToken, translate, className = "", onItemClick }) {
  const location = useLocation();

  const isReactNativeApp = typeof window !== "undefined" && !!window.ReactNativeWebView;
  // AppView sirf RN app me aur bina subscription/plan wale users ke liye (flag App.js set karta hai)
  const showAppView = isReactNativeApp && localStorage.getItem("planRestricted") === "true";

  const isActive = (to) => {
    if (to === "/") {
      return location.pathname === "/";
    }

    // Routes case-insensitive hai (/PlansApp == /plansapp)
    return location.pathname.toLowerCase().startsWith(to.toLowerCase());
  };

  const selectedLanguage = localStorage.getItem("selectedLanguage") || "hindi";
  const localTranslations = translations[selectedLanguage === "hindi" ? "hindi" : "english"];

  return (
    <nav className={`home-v2-bottom-nav ${className}`.trim()}>
      {FOOTER_ITEMS.map((item) => {
        const Icon = item.icon;
        const useAppRoute = showAppView || (isReactNativeApp && item.appAlways);
        const href = authToken
          ? (useAppRoute && item.appAuthenticatedTo) || item.authenticatedTo
          : item.guestTo;
        const label =
          (useAppRoute && item.appLabel) ||
          localTranslations?.[item.labelKey] ||
          translate?.message?.data?.[item.labelKey] ||
          item.fallbackLabel;
        const active = isActive(href);

        return (
          <Link
            key={item.key}
            to={href}
            className={`home-v2-bottom-nav-item ${active ? "active" : ""}`}
            onClick={() => onItemClick?.(item)}
          >
            <Icon className="home-v2-bottom-nav-icon" />
            <span>{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}

export default FooterNav;
